import { POST, GET } from '@/utils/request'
import Api from './url'

export const getDetailInfoData = async (params: object) => {
  return await GET({
    url: Api.getDetailInfoData,
    params,
    showError: false
  })
}
